import { isValidString } from '../../../common/CommonUtilsMethods';
import {
  RequiredAttributeType,
  WorkTaskFormSectionRequestDTO,
  WorkTaskTemplateResponseDTO,
} from '../worktasks/WorkTaskTemplateInterfaces';

enum JobberOnboardingTemplateType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

interface CreateJobberOnboardingTemplateRequestDTO {
  readonly templateName: string;
  readonly sections: readonly WorkTaskFormSectionRequestDTO[];
  readonly requiredAttributes?: readonly RequiredAttributeType[];
  readonly workTaskDisplayConfigTemplateId?: string | null;
  readonly jobberOnboardingTemplateType?: JobberOnboardingTemplateType | null;
}

interface UpdateJobberOnboardingTemplateRequestDTO {
  readonly templateId: string;
  readonly templateName: string;
  readonly sections: readonly WorkTaskFormSectionRequestDTO[];
  readonly requiredAttributes?: readonly RequiredAttributeType[];
  readonly workTaskDisplayConfigTemplateId?: string | null;
  readonly jobberOnboardingTemplateType?: JobberOnboardingTemplateType | null;
}

interface UpdateJobberOnboardingTemplateTypeRequestDTO {
  readonly templateId: string;
  readonly jobberOnboardingTemplateType: JobberOnboardingTemplateType;
}

const JOBBER_ONBOARDING_DEFAULT_TEMPLATE_TOOLTIP: string =
  'Primary forms are assigned to new workers who join without a specific onboarding form selected, such as through an invite link. Only one primary form can be active at a time.';

const resolveJobberOnboardingTemplateType = (
  type: JobberOnboardingTemplateType | string | null | undefined
): JobberOnboardingTemplateType => {
  if (type === JobberOnboardingTemplateType.PRIMARY || type === 'PRIMARY') {
    return JobberOnboardingTemplateType.PRIMARY;
  }
  return JobberOnboardingTemplateType.SECONDARY;
};

const isPrimaryJobberOnboardingTemplate = (
  type: JobberOnboardingTemplateType | string | null | undefined
): boolean => {
  return resolveJobberOnboardingTemplateType(type) === JobberOnboardingTemplateType.PRIMARY;
};

const getJobberOnboardingTemplateTypeLabel = (
  type: JobberOnboardingTemplateType | string | null | undefined
): string => {
  if (isPrimaryJobberOnboardingTemplate(type)) {
    return 'Primary';
  }
  return 'Secondary';
};

const isJobberOnboardingTemplateActivated = (
  template: WorkTaskTemplateResponseDTO
): boolean => {
  if (!isValidString(template.templateStatus)) {
    return true;
  }
  return template.templateStatus === 'ACTIVATED';
};

export {
  JobberOnboardingTemplateType,
  JOBBER_ONBOARDING_DEFAULT_TEMPLATE_TOOLTIP,
  resolveJobberOnboardingTemplateType,
  isPrimaryJobberOnboardingTemplate,
  getJobberOnboardingTemplateTypeLabel,
  isJobberOnboardingTemplateActivated,
};
export type {
  CreateJobberOnboardingTemplateRequestDTO,
  UpdateJobberOnboardingTemplateRequestDTO,
  UpdateJobberOnboardingTemplateTypeRequestDTO,
};
